type BlockExtent = Pick<DOMRect, 'top' | 'bottom'>;

const PAGE_HEADING = 'h1';

export const overlapsBlock = (a: BlockExtent, b: BlockExtent): boolean => a.bottom > b.top && a.top < b.bottom;

export const keepFocusClearOf = (dock: HTMLElement): void => {
  const active = dock.ownerDocument.activeElement;
  if (!(active instanceof HTMLElement) || dock.contains(active)) return;
  if (overlapsBlock(active.getBoundingClientRect(), dock.getBoundingClientRect())) {
    active.scrollIntoView({ block: 'nearest' });
  }
};

const focusHeading = (heading: HTMLElement): void => {
  if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
  heading.focus();
};

export const focusPageHeading = (doc: Document = document): void => {
  const heading = doc.querySelector<HTMLElement>(PAGE_HEADING);
  if (heading === null) return;
  focusHeading(heading);
};

const focusIsUnplaced = (doc: Document, screen: HTMLElement, from: Element | null): boolean => {
  const active = doc.activeElement;
  if (active === null || active === doc.body) return true;
  return active === from && !screen.contains(active);
};

export const ARRIVAL_WAIT_MS = 10_000;

export const focusPageHeadingOnArrival = (screen: HTMLElement, waitMs: number = ARRIVAL_WAIT_MS): (() => void) => {
  const doc = screen.ownerDocument;
  const from = doc.activeElement;
  const settle = (): boolean => {
    if (!focusIsUnplaced(doc, screen, from)) return true;
    const heading = screen.querySelector<HTMLElement>(PAGE_HEADING);
    if (heading === null) return false;
    focusHeading(heading);
    return true;
  };
  if (settle()) return () => undefined;
  const observer = new MutationObserver(() => {
    if (settle()) stop();
  });
  const timer = setTimeout(() => observer.disconnect(), waitMs);
  const stop = (): void => {
    clearTimeout(timer);
    observer.disconnect();
  };
  observer.observe(screen, { childList: true, subtree: true });
  return stop;
};
